import { memo, useEffect } from 'react';
import {
  Box,
  Card,
  CardHeader,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getTankList } from 'src/redux/tankSlice';
import SyncIcon from '@mui/icons-material/Sync';
import { getFormattedDate, getFuelQuantity } from 'src/utils/getInitials';
import { DATE_FORMAT } from 'src/utils/constants';
import Loader from 'src/common/Loader';

const StockInfo = () => {
  const dispatch = useDispatch();
  const { loading, tankList } = useSelector((state) => state.tanks);

  const fetchTankData = () => {
    dispatch(getTankList({ limit: 5 }));
  };

  useEffect(() => {
    fetchTankData();
  }, []);

  const lastUpdated = getFormattedDate(new Date(), DATE_FORMAT.date);

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader
        title="Available Stock"
        action={(
          <Tooltip title="Refresh Stock">
            <IconButton aria-label="sync" onClick={fetchTankData}>
              <SyncIcon />
            </IconButton>
          </Tooltip>
        )}
      />
      <Divider />
      <Box sx={{ height: 400, overflow: 'auto' }}>
        {loading ? <Loader />
          : (
            <List>
              {tankList.map((tank) => (
                <ListItem
                  divider
                  key={tank.id}
                >
                  <ListItemText
                    primary={tank.name}
                    secondary={lastUpdated}
                    secondaryTypographyProps={{ fontSize: 14 }}
                  />
                  <ListItemText
                    sx={{ textAlign: 'right' }}
                    primary={getFuelQuantity(tank.current_balance)}
                    primaryTypographyProps={{ fontWeight: 400 }}
                  />
                </ListItem>
              ))}
            </List>
          )}
      </Box>
    </Card>
  );
};

export default memo(StockInfo);
